module.exports = __webpack_public_path__ + "static/img/logo.0df93e44.svg";